import React from "react";

interface ConfiguratorTitleProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar: React.FC<ConfiguratorTitleProps> = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full max-width-100 h-[15px] bg-gray-200 rounded-full mb-4 mt-4 relative">
      <div
        className="absolute h-full bg-red-600 rounded-full"
        style={{
          maxWidth: "100%",
          width: progress === 100 ? `calc(100% - 2px)` : `${progress}%`,
          marginRight: progress === 100 ? "1px" : "0",
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
